// extracted by mini-css-extract-plugin
export default {"cls1":"MocUy0laLXdwdKbfF6UR","cls2":"WRWFFjLryRKsY_WvW3CY MocUy0laLXdwdKbfF6UR"};